import useSWR from "swr";

const BASE_URL_CAMPAIGN = "https://api.holdstation.com/api/cms-campaigns/active";

export interface ResponsiveDataCampaign {
    success: boolean;
    message: string;
    code: string;
    innerMessage: string;
    data: CampaignType[];
}

export interface CampaignType {
    id: number;
    title: string;
    shortDesc: string;
    content: string;
    seeMoreUrl: string;
    timeLine: TimeLine[];
    backgroundImage: string;
    mobileBackground: string;
    thumbnailImage: string;
    subTitle: string;
}

export interface TimeLine {
    title: string;
    time: string;
}

export async function getDataCampaign() {
    const res = await fetch(BASE_URL_CAMPAIGN);
    if (!res.ok) {
        throw new Error("Error Data Campaign");
    }

    const data: ResponsiveDataCampaign = await res.json();
    return data.data;
}


export function useCampaign() {

    return useSWR("campaignData", getDataCampaign);

}